import apiClient from "./axios"

export const getEngineCodes = async (params = {}) => {
  const { data } = await apiClient.get("/engine-codes", { params })
  return data
}

export const getEngineCode = async id => {
  const { data } = await apiClient.get(`/engine-codes/${id}`)
  return data
}

export const createEngineCode = async engineCodeData => {
  const { data } = await apiClient.post("/engine-codes", engineCodeData)
  return data
}

export const editEngineCode = async ({ id, ...engineCodeData }) => {
  const { data } = await apiClient.patch(`/engine-codes/${id}`, engineCodeData)
  return data
}

export const deleteEngineCode = async id => {
  const { data } = await apiClient.delete(`/engine-codes/${id}`)
  return data
}
